const projectsSortReducer = (
    state = {},
    action: {
      type: "SET_PROJECTS_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_PROJECTS_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default projectsSortReducer;